module.exports = __webpack_public_path__ + "img/icon-3d_scan.f59794b1.svg";